import React, { useEffect, useState, useCallback, useRef } from 'react'
import {connect} from 'react-redux';
import { PreTicketVistaCard, TicketVistaCard } from '@app/components/index';
import TablaTicketService from '@app/services/tablaTicket.service';
import CustomExternalTicketService from '@app/services/customExternal.service';

const ITEMS_PER_PAGE = 15;

function TabsTicketPendiente({
    ticketrefresh
}) {
    const [tickets, setTickets] = useState([]);
    const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
    const observerRef = useRef(null);

    const lastItemRef = useCallback((node) => {
        if (observerRef.current) observerRef.current.disconnect();
        observerRef.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && visibleCount < tickets.length) {
                setVisibleCount((prev) => Math.min(prev + ITEMS_PER_PAGE, tickets.length));
            }
        });
        if (node) observerRef.current.observe(node);
    }, [visibleCount, tickets.length]);

    const actualizar = () =>{
        CustomExternalTicketService.getAll()
        .then((response)=>{
            setTickets(Array.isArray(response) ? response : []);
            setVisibleCount(ITEMS_PER_PAGE);
        })
        .catch(() => {
            setTickets([]);
        })
    }
    const onGuardar = () => actualizar();
    useEffect(() => {
        actualizar();
    }, [])

    useEffect(() => {
        if(ticketrefresh?.reloadingPendiente){
            actualizar();
        }
    }, [ticketrefresh])

    const visibleItems = tickets.slice(0, visibleCount);

    return (
        <div className="p-3 p-lg-5">
            {tickets.length > 0 && (
                <div className="mb-3">
                    <span
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: '#dc3545',
                            color: '#fff',
                            borderRadius: '20px',
                            padding: '4px 12px',
                            fontSize: '13px',
                            fontWeight: '600',
                        }}
                    >
                        <i className="fas fa-ticket-alt mr-1" />
                        {tickets.length}
                        {' ticket'}
                        {tickets.length !== 1 ? 's' : ''}
                    </span>
                </div>
            )}
            <div className="row">
                <div className="offset-lg-12 col-lg-12">
                    {tickets && tickets?.length > 0 ? (
                        <>
                            {visibleItems.map((ticket, index) => {
                                const isLast = index === visibleItems.length - 1;
                                return (
                                    <div
                                        ref={isLast ? lastItemRef : null}
                                        key={ticket.id_ptk}
                                        className="mb-3"
                                    >
                                        <PreTicketVistaCard
                                            item={ticket}
                                            onGuardar={onGuardar}
                                        />
                                    </div>
                                )
                            })}
                            {visibleCount < tickets.length && (
                                <div className="text-center py-3">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">
                                            Cargando...
                                        </span>
                                    </div>
                                </div>
                            )}
                        </>
                    ):(
                        <div className='alert alert-light mt-2 text-center'>
                            <i className="fas fa-inbox" style={{fontSize: 200, color: 'gray'}} />
                            <div style={{fontSize: 20, color: 'gray'}}>
                                No hay tickets pendientes
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    ticketrefresh: state.ticketrefresh
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(TabsTicketPendiente)